import styled from 'styled-components';
import { Z_INDEXES } from '../../util/vars';
import { BUTTON_WRAPPER, PREFIX } from '../../util/data-id';

export const DropdownWrapperStyled = styled('div')<{ $forceBorder: boolean }>`
  position: relative;
  flex: 1;
  [data-id=${BUTTON_WRAPPER}] {
    ${(props) => props.$forceBorder && `border-color: ${props.theme.colors.light};`}
    border-radius: ${(props) => props.theme.radius.input};
  }
`;

export const DropdownMenuStyled = styled('div')<{ $withSearch: boolean }>`
  position: absolute;
  width: 100%;
  ${(props) => props.$withSearch && 'margin-top: 10px;'}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: ${(props) => (!props.$withSearch ? '0' : props.theme.radius.input)} ${(props) => (!props.$withSearch ? '0' : props.theme.radius.input)} 0 0;
  ${(props) => props.$withSearch && 'box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);'}  
  
  .${PREFIX}__control {
    margin: ${(props) => `calc(${props.theme.sizes.sm} / 5)`};
    box-shadow: none !important;
    border: none !important;
    input:focus {
      box-shadow: none !important;
      border: none !important;
    }
  } 
  .${PREFIX}__menu {
    ${(props) => props.$withSearch && `margin-top: calc(${props.theme.sizes.sm} / 5);`}
    border-radius: ${(props) => (props.$withSearch ? '0' : '2px')} ${(props) =>
  props.$withSearch ? '0' : '2px'} 2px 2px;
  }
`;

export const DropdownMaskStyled = styled('div')`
  position: fixed;
  z-index: ${Z_INDEXES.level_1};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
